import React, { useState } from "react";
import PostUploadForm from "../components/PostUploadForm";
import EventCreateForm from "../components/EventCreateForm";

export default function Create() {
  const [isPost, setIsPost] = useState(true);

  const toggleCreate = () => {
    setIsPost((isPost) => !isPost);
  };

  return (
    <div className="p-4 max-w-xl mx-auto">
      <div className="flex space-x-2 p-4">
        <h2>Create a[n] </h2>
        {isPost ? (
          <div className="flex-col">
            <h2>
              <strong>Post</strong>
            </h2>
            <div>
              <p className="text-xs text-gray-500 indent-2">
                <i>Share a photo, video, or text update.</i>
              </p>
            </div>
            <button onClick={toggleCreate}>
              <h2>Event</h2>
            </button>
          </div>
        ) : (
          <div className="flex-col">
            <h2>
              <strong>Event</strong>
            </h2>
            <div>
              <p className="text-xs text-gray-500 indent-2">
                <i>Don't forget to invite your friends!</i>
              </p>
            </div>
            <button onClick={toggleCreate}>
              <h2>Post</h2>
            </button>
          </div>
        )}
      </div>
      {isPost ? <PostUploadForm /> : <EventCreateForm />}
    </div>
  );
}
